/****************************************************************************
 ** @license
 ** This demo file is part of yFiles for HTML 2.4.0.3.
 ** Copyright (c) 2000-2021 by yWorks GmbH, Vor dem Kreuzberg 28,
 ** 72070 Tuebingen, Germany. All rights reserved.
 **
 ** yFiles demo files exhibit yFiles for HTML functionalities. Any redistribution
 ** of demo files in source code or binary form, with or without
 ** modification, is not permitted.
 **
 ** Owners of a valid software license for a yFiles for HTML version that this
 ** demo is shipped with are allowed to use the demo source code as basis
 ** for their own yFiles for HTML powered applications. Use of such programs is
 ** governed by the rights and conditions as set out in the yFiles for HTML
 ** license agreement.
 **
 ** THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESS OR IMPLIED
 ** WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 ** MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
 ** NO EVENT SHALL yWorks BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 ** SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 ** TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 ** PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 ** LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 ** NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 ** SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 **
 ***************************************************************************/
// @ts-ignore
import React, { Component } from 'react'
import './DemoToolbar.css'
import { IconButton, Typography } from '@material-ui/core';
import SaveIcon from "@material-ui/icons/Save";

interface DemoToolbarProps {
  resetData(): void
  resetZoom(): void
  fitContent(): void
  zoomIn(): void
  zoomOut(): void
  searchChange(e: React.ChangeEvent<HTMLInputElement>): void
  saveGraph(): void
  loadGraph(): void
  isRefreshing?: boolean
  setIsRefreshing?: React.Dispatch<React.SetStateAction<boolean>>
  saveStatus?: string
  setSaveStatus?: React.Dispatch<React.SetStateAction<string>>
}

export default class DemoToolbar extends Component<DemoToolbarProps> {
  render(): JSX.Element {
    return (
      <div className="demo-toolbar">
        <button className="demo-icon-yIconZoomIn" title="Zoom In" onClick={this.props.zoomIn} />
        <button
          className="demo-icon-yIconZoomOriginal"
          title="Reset Zoom"
          onClick={this.props.resetZoom}
        />
        <button className="demo-icon-yIconZoomOut" title="Zoom Out" onClick={this.props.zoomOut} />
        <button
          className="demo-icon-yIconZoomFit"
          title="Fit Diagram"
          onClick={this.props.fitContent}
        />
        <span className="demo-separator" />
        <IconButton 
          disabled={this.props.isRefreshing} 
          onClick={this.props.saveGraph} 
          aria-label="Save" 
          title="Save Current Graph Layout" 
          style={{color: '#667', marginLeft: 0}}>
          <SaveIcon />
        </IconButton>
        <Typography variant="h6" style={{ color: "#b3b3b3", paddingLeft: 5 }}>{this.props.saveStatus}</Typography>
        <input className="search" placeholder="Search Nodes" onChange={this.props.searchChange} />
      </div>
    )
  }
}
